import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Play, ArrowUpRight } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

// Runs a dashboard action (with confirm) or navigates when the action is a shortcut to a page.
export function ActionButton({ action, onDone, size = 'sm', tone = 'navy' }) {
  const { http } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!action.allowed) return null;
  const run = async () => {
    if (action.navigate) { navigate(action.navigate); return; }
    if (action.confirm && !window.confirm(action.confirm)) return;
    setBusy(true);
    try {
      const { data } = await http.post(`/admin/dashboard/action/${action.key}`);
      if (data.navigate) { navigate(data.navigate); return; }
      toast.success(data.message || `${action.label} done.`);
      onDone && onDone(data.values);
    } catch (e) {
      toast.error((e.response && e.response.data && e.response.data.detail) || `${action.label} failed.`);
    }
    setBusy(false);
  };
  const bg = tone === 'maroon' ? 'var(--maroon)' : tone === 'ghost' ? 'transparent' : 'var(--navy)';
  const pad = size === 'lg' ? 'px-4 py-2.5 text-sm' : 'px-2.5 py-1.5 text-xs';
  return (
    <button type="button" onClick={run} disabled={busy}
      className={`inline-flex items-center gap-1.5 rounded font-title transition-transform hover:-translate-y-0.5 ${pad}`}
      style={{ background: bg, color: tone === 'ghost' ? 'var(--navy)' : 'var(--cream)', border: tone === 'ghost' ? '1px solid var(--navy)' : 'none', opacity: busy ? 0.7 : 1 }}
      data-testid={`ops-action-${action.key}`}>
      {busy ? <Loader2 size={13} className="animate-spin" /> : action.navigate ? <ArrowUpRight size={13} /> : <Play size={13} />}
      {action.label}
    </button>
  );
}
